import { render } from "./LoadingPage.vue?vue&type=template&id=5b98ebb2&ts=true"
import script from "./LoadingPage.vue?vue&type=script&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__